module.exports = __webpack_public_path__ + "static/media/info.0dcb7894.svg";